import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromStatusLog from './reducers/status-log.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StatusLogEffects } from './effects/status-log.effects';
import * as fromStatusAggregation from './reducers/status-aggregation.reducer';
import { StatusAggregationEffects } from './effects/status-aggregation.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('statusLog', fromStatusLog.reducer),
    EffectsModule.forFeature([StatusLogEffects, StatusAggregationEffects]),
    StoreModule.forFeature('statusAggregation', fromStatusAggregation.reducer)
  ]
})
export class StatusModule { }
